import { render, staticRenderFns } from "./setAdv.vue?vue&type=template&id=75239a22&scoped=true&"
import script from "./setAdv.vue?vue&type=script&lang=js&"
export * from "./setAdv.vue?vue&type=script&lang=js&"
import style0 from "./setAdv.vue?vue&type=style&index=0&id=75239a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75239a22",
  null
  
)

component.options.__file = "setAdv.vue"
export default component.exports